if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.submitBtn = this.querySelector('[data-sticky-submit]');
        this.submitLabel = this.querySelector('[data-sticky-submit-label]');

        if (!this.submitBtn) return;

        this.boundClick = () => {
          const target = this.getTargetSubmit();
          if (target) target.click();
        };
        this.submitBtn.addEventListener('click', this.boundClick);

        this.observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            this.classList.toggle('sticky-atc--visible', !!entry && !entry.isIntersecting);
          },
          { threshold: 0 }
        );

        this.syncFromLive();
        this.observeTarget();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => {
            this.syncFromLive();
            this.observeTarget();
          });
        }

        this.boundPlanChanged = () => this.syncFromLive();
        document.addEventListener('lifeseeds:subscription:planChanged', this.boundPlanChanged);

        // Cart drawer, mobile menu, pickup-availability, etc. all lock scroll
        // by adding an `overflow-hidden*` class to <body> (see cart-drawer.js,
        // details-modal.js, global.js). Suppress the bar whenever one of those
        // overlays is open so it never floats above a drawer/modal.
        this.syncSuppressed();
        this.bodyObserver = new MutationObserver(() => this.syncSuppressed());
        this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      }

      disconnectedCallback() {
        if (this.submitBtn && this.boundClick) {
          this.submitBtn.removeEventListener('click', this.boundClick);
        }
        if (this.observer) this.observer.disconnect();
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
        if (this.boundPlanChanged) {
          document.removeEventListener('lifeseeds:subscription:planChanged', this.boundPlanChanged);
        }
        if (this.bodyObserver) this.bodyObserver.disconnect();
      }

      syncSuppressed() {
        const suppressed = Array.from(document.body.classList).some((cls) => cls.startsWith('overflow-hidden'));
        this.classList.toggle('sticky-atc--suppressed', suppressed);
      }

      getTargetForm() {
        return document.querySelector('form[data-type="add-to-cart-form"]');
      }

      getTargetSubmit() {
        const form = this.getTargetForm();
        return form ? form.querySelector('[type="submit"]') : null;
      }

      observeTarget() {
        const target = this.getTargetSubmit();
        if (!this.observer || !target) return;
        this.observer.disconnect();
        this.observer.observe(target);
      }

      syncFromLive() {
        const target = this.getTargetSubmit();
        if (target && this.submitBtn) {
          this.submitBtn.disabled = target.disabled;
          const label = target.querySelector('span');
          if (label && this.submitLabel) {
            this.submitLabel.textContent = label.textContent.trim();
          }

          const targetStyle = getComputedStyle(target);
          this.submitBtn.style.backgroundColor = targetStyle.backgroundColor;
          this.submitBtn.style.color = targetStyle.color;
          this.submitBtn.style.borderColor = targetStyle.borderColor;
        }
      }
    }
  );
}
